<div class="wetter_content_container">
  <div class="bericht-text-container">
    <h3>Headline</h3>
    {{rundschauWetterbericht?.headline}}
  </div>
  <div class="bericht-text-container">
    <h3>{{rundschauWetterbericht?.caption_europa}}</h3>
    {{rundschauWetterbericht?.wx_europa}}
  </div>
  <div class="bericht-text-container">
    <h3>{{rundschauWetterbericht?.caption_brd}}</h3>
    {{rundschauWetterbericht?.wx_brd}}
  </div>
  <div class="bericht-text-container">
    <h3>{{rundschauWetterbericht?.caption_wolkenfilm}}</h3>
    {{rundschauWetterbericht?.wx_wolkenfilm}}
  </div>
  <div class="bericht-text-container">
    <h3>{{rundschauWetterbericht?.caption_franken}}</h3>
    {{rundschauWetterbericht?.wx_franken}}
  </div>
  <div class="bericht-text-container">
    <h3>{{rundschauWetterbericht?.caption_oberbayern_schwaben}}</h3>
    {{rundschauWetterbericht?.wx_oberbayern_schwaben}}
  </div>
  <div class="bericht-text-container">
    <h3>{{rundschauWetterbericht?.caption_niederbayern_oberpfalz}}</h3>
    {{rundschauWetterbericht?.wx_niederbayern_oberpfalz}}
  </div>
  <div class="bericht-text-container">
    <h3>{{rundschauWetterbericht?.caption_wx_next_days}}</h3>
    {{rundschauWetterbericht?.wx_next_days}}
  </div>
  <div class="bericht-text-container">
    {{rundschauWetterbericht?.footer}}
  </div>
</div>
